<div class="status-dropdown-container">
  <!-- Status Button Trigger -->
  <div (click)="toggleDropdown($event)" class="d-flex align-items-center cursor-pointer status-button">
    <span [innerHTML]="selectedStatus?.svg"></span>
    <span class="ml-2">{{ selectedStatus?.title }}</span>
  </div>

  <!-- Custom Dropdown Menu -->
  <div class="custom-dropdown-menu" [class.show]="isDropdownOpen" [class.width-default]="!isDurationClicked"
    [class.width-expanded]="isDurationClicked">
    <!-- Main Status Menu -->
    @if (!isDurationClicked) {
      <div class="dropdown-content">
        <!-- Status Options -->
        @for (statusSlug of apiStatuses; track statusSlug) {
          <div class="status-option"
            (click)="setStatus(getStatusBySlug(statusSlug)?.title, $event)">
        <span [ngStyle]="
            getStatusBySlug(statusSlug)?.title === 'Do not disturb'
              ? { position: 'relative', left: '-2px' }
              : {}
          " [innerHTML]="getStatusBySlug(statusSlug)?.svg"></span>
            <span class="pl-1 text-white">{{
              getStatusBySlug(statusSlug)?.title
            }}</span>
          </div>
        }
        <!-- Divider -->
        <div class="dropdown-divider"></div>
        <!-- Duration Button -->
        <div class="status-option duration-option" (click)="onDurationClick($event)">
          <div class="duration_wrapper">
            <svg fill="#C7C4E1" width="17px" height="17px" viewBox="0 0 20 20" xmlns="http://www.w3.org/2000/svg">
              <g id="SVGRepo_bgCarrier" stroke-width="0"></g>
              <g id="SVGRepo_tracerCarrier" stroke-linecap="round" stroke-linejoin="round"></g>
              <g id="SVGRepo_iconCarrier">
                <path
                  d="M10 20a10 10 0 1 1 0-20 10 10 0 0 1 0 20zm0-2a8 8 0 1 0 0-16 8 8 0 0 0 0 16zm-1-7.59V4h2v5.59l3.95 3.95-1.41 1.41L9 10.41z">
                </path>
              </g>
            </svg>
            <span class="pl-1 text-white">Duration</span>
          </div>
          <div class="arrow_icon">
            <mat-icon class="right-icon">chevron_right</mat-icon>
          </div>
        </div>
        <!-- Divider -->
        <div class="dropdown-divider"></div>
        <!-- Reset Status Button -->
        <div class="status-option" (click)="resetStatus($event)">
          <svg width="17px" height="17px" viewBox="0 0 20 20" xmlns="http://www.w3.org/2000/svg" fill="#000000">
            <g id="SVGRepo_bgCarrier" stroke-width="0"></g>
            <g id="SVGRepo_tracerCarrier" stroke-linecap="round" stroke-linejoin="round"></g>
            <g id="SVGRepo_iconCarrier">
              <path
                d="M17 9a1 1 0 01-1-1c0-.551-.448-1-1-1H5.414l1.293 1.293a.999.999 0 11-1.414 1.414l-3-3a.999.999 0 010-1.414l3-3a.997.997 0 011.414 0 .999.999 0 010 1.414L5.414 5H15c1.654 0 3 1.346 3 3a1 1 0 01-1 1zM3 11a1 1 0 011 1c0 .551.448 1 1 1h9.586l-1.293-1.293a.999.999 0 111.414-1.414l3 3a.999.999 0 010 1.414l-3 3a.999.999 0 11-1.414-1.414L14.586 15H5c-1.654 0-3-1.346-3-3a1 1 0 011-1z"
              fill="#C7C4E1"></path>
            </g>
          </svg>
          <span class="pl-1 text-white">Reset status</span>
        </div>
      </div>
    }

    <!-- Duration Settings Menu -->
    @if (isDurationClicked) {
      <div class="dropdown-content">
        <!-- Header -->
        <div class="menu-header" (click)="$event.stopPropagation()">
          <button (click)="menuItemshow($event)" class="back-button">
            <mat-icon>arrow_back</mat-icon> Back
          </button>
        </div>
        <!-- Form Content -->
        <div class="menu-content user-status-wrapper py-4" (click)="$event.stopPropagation()"
          [formGroup]="userStatusForm">
          <div class="form-group col-12 mb-4">
            <label class="custom_label">Status</label>
            <ng-select [items]="statuses" placeholder="Select status" [closeOnSelect]="true" formControlName="status"
              bindLabel="title" (change)="onStatusChange($event)">
              <ng-template ng-option-tmp let-item="item">
                <span [innerHTML]="item.svg"></span>
                <span class="pl-2">{{ item.title }}</span>
              </ng-template>
              <ng-template ng-label-tmp let-item="item">
                <span [innerHTML]="item?.svg"></span>
                <span class="pl-2">{{ item?.title }}</span>
              </ng-template>
            </ng-select>
            <app-validation-error [formGroup]="userStatusForm" [controlName]="'status'"></app-validation-error>
          </div>
          <div class="form-group col-12">
            <label class="custom_label">Reset status after</label>
            <ng-select [items]="resetTimes" placeholder="Select time" [closeOnSelect]="true" formControlName="resetTime"
              bindLabel="time">
              <ng-template ng-option-tmp let-item="item">
                <span>{{ item.time }}</span>
              </ng-template>
            </ng-select>
            <app-validation-error [formGroup]="userStatusForm" [controlName]="'resetTime'"></app-validation-error>
          </div>
          @if (userStatusForm.get('resetTime')?.value?.time === 'Custom') {
            <div class="d-flex justify-content-between">
              <div class="form-group col-6" (click)="onDatePickerClick($event)">
                <label class="custom_label">Select Date</label>
                <div class="date-picker-container">
                  <mat-form-field appearance="fill" class="w-100 date-field">
                    <input matInput [matDatepicker]="picker" formControlName="customDate" placeholder="Choose a date"
                      (dateChange)="onDateChange($event)" />
                    <mat-datepicker-toggle matSuffix [for]="picker"></mat-datepicker-toggle>
                    <mat-datepicker #picker></mat-datepicker>
                  </mat-form-field>
                </div>
                <app-validation-error [formGroup]="userStatusForm" [controlName]="'customDate'"></app-validation-error>
              </div>
              <div class="form-group col-6">
                <label class="custom_label">Time</label>
                <ng-select [items]="timeSlots" placeholder="Select time" [closeOnSelect]="true" formControlName="timeSlots"
                  bindLabel="time">
                  <ng-template ng-option-tmp let-item="item">
                    <span>{{ item?.time }}</span>
                  </ng-template>
                </ng-select>
                <app-validation-error [formGroup]="userStatusForm" [controlName]="'timeSlots'"></app-validation-error>
              </div>
            </div>
          }
        </div>
        <!-- Footer -->
        <div class="menu-footer" (click)="$event.stopPropagation()">
          <button class="primary_button" (click)="onSaveStatus()">Done</button>
        </div>
      </div>
    }
  </div>
</div>